export type ZohoInboundContactSyncSettings = {
  autoSync: boolean
}

export type ZohoInboundSyncSettings = {
  contact: ZohoInboundContactSyncSettings
}

export type ZohoSettingsFormValues = {
  inbound: ZohoInboundSyncSettings
}

export const zohoSettingsDefaultValues: ZohoSettingsFormValues = {
  inbound: {
    contact: {
      autoSync: false,
    },
  },
}
